import React from 'react';
class MenuContainer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            activeCategories: this.props.initialActiveCategories || []
        };
        this.setActiveCategory = (activeCategory) => {
            var _a, _b;
            const allowMultipleActive = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.allowMultipleActive) !== null && _b !== void 0 ? _b : false;
            this.setState(({ activeCategories }) => ({
                activeCategories: allowMultipleActive
                    ? [...activeCategories, activeCategory]
                    : [activeCategory]
            }));
        };
        this.removeActiveCategory = (category) => {
            this.setState(({ activeCategories }) => {
                return {
                    activeCategories: activeCategories.filter((cat) => cat.id !== category.id)
                };
            });
        };
        this.toggleActiveCategory = (category) => {
            this.state.activeCategories.find((cat) => cat.id === category.id)
                ? this.removeActiveCategory(category)
                : this.setActiveCategory(category);
        };
        this.clearActiveCategories = () => {
            this.setState({ activeCategories: [] });
        };
        this.isActiveCategory = (category) => !!this.state.activeCategories.find((cat) => cat.id === category.id);
    }
    render() {
        return this.props.children({
            activeCategories: this.state.activeCategories,
            setActiveCategory: this.setActiveCategory,
            removeActiveCategory: this.removeActiveCategory,
            toggleActiveCategory: this.toggleActiveCategory,
            isActiveCategory: this.isActiveCategory,
            clearActiveCategories: this.clearActiveCategories
        });
    }
}
export default MenuContainer;
//# sourceMappingURL=MenuContainer.js.map